@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title | uppercase}}" [(visible)]="display" showEffect="fade" [modal]="true"
    appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- #region BODY -->
    <div class="container-md">
      <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
        </div>
      </div>
      <!-- FRAME NUMBER & LAST -->
      <div class="row justify-content-start mt-3">
        <div class="col-sm-6">
          <form-input [required]="false" [align]="'stacked'" fieldName="{{ 'control-panel.vehicles.licensePlate' | translate }}">
            <input type="text" class="form-control custom-input" [(ngModel)]="entity.vehicle.name" [disabled]="true"
              [style]="{ width: '100%' }">
          </form-input>
        </div>
        @if (isNew) {
          <div class="col-sm-6">
            <form-input [required]="false" [align]="'stacked'" fieldName="{{ 'tableManagement.mileage.last' | translate }}">
              <input type="text" class="form-control custom-input" [(ngModel)]="lastKM" [disabled]="true"
                [style]="{ width: '100%' }">
            </form-input>
          </div>
        }
      </div>
      <hr>
        <!-- DATE & MILEAGE -->
        <div class="row justify-content-start mt-3">
          <div class="col-sm-6">
            <form-input [required]="false" [align]="'stacked'" fieldName="{{ 'general.date' | translate }}">
              <p-datepicker [(ngModel)]="readingDate" [showTime]="true" [disabled]='!canEdit'
                [style]="{ width: '100%' }" dateFormat="{{ i18n.dateFormat }}" showIcon="true"
              appendTo="body"></p-datepicker>
            </form-input>
          </div>
          <div class="col-sm-6">
            <form-input [required]="false" [align]="'stacked'" fieldName="{{ 'tableManagement.mileage.mileage' | translate }}">
              <input type="number" class="form-control custom-input" [(ngModel)]="entity.kms" [disabled]='!canEdit'
                [style]="{ width: '100%' }" (keypress)="validateIntegerInput($event)">
            </form-input>
          </div>
        </div>
      </div>
      <!-- #endregion BODY -->
    </div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
        <div class="d-flex justify-content-center bd-highlight">
          <div class="p-2 bd-highlight">
            @if (isNew) {
              <div>
                <button class="btn custom-button" (click)="saveChanges()" [disabled]='!canEdit' i18n>
                        {{'general.create' | translate}}
                    </button>
              </div>
            }
            @if (!isNew) {
              <div>
                <button class="btn custom-button" (click)="saveChanges()" [disabled]='!canEdit' i18n>
                        {{'general.save' | translate}}
                    </button>
              </div>
            }
          </div>
        </div>
      </ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
  }